import React from 'react'
import { formatMessageNew } from '@/utils/common'

const Page404 = () => {
  return (
    <div
      className="content-container"
      style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}
    >
      <div style={{ fontSize: '22px', textAlign: 'center' }}>
        <p style={{ marginBottom: '10px', fontSize: '25px', color: 'red' }}>
          {formatMessageNew('languageObj.commonLocale.errorAuth')}
        </p>
        <p>{formatMessageNew('languageObj.commonLocale.error404')}</p>
      </div>
    </div>
  )
}

export default Page404
